'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');
const theme_LegacyColorMap = require('../../../../theme/LegacyColorMap.cjs.js');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
require('../../../../theme/Shadows.cjs.js');
require('../../../../theme/Typography.cjs.js');
const components_display_Heading_Heading = require('../../../display/Heading/Heading.cjs.js');
require('../../../../utils/heading-level-context/HeadingLevelContext.cjs.js');
const components_display_Icon_Icon = require('../../../display/Icon/Icon.cjs.js');
const components_display_Tag_Tag = require('../../../display/Tag/Tag.cjs.js');
const components_display_Text_Text = require('../../../display/Text/Text.cjs.js');
const components_layout_Grid_Grid = require('../../../layout/Grid/Grid.cjs.js');
const components_navigation_LegacyButton_Button = require('../../../navigation/LegacyButton/Button.cjs.js');
require('../../../forms/TextInput/TextInput.cjs.js');
const components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer = require('../../SubscriptionForm/SubscriptionFormWithDisclaimer.cjs.js');
require('../../../navigation/Link/Link.cjs.js');
const components_marketing_Hero_utils = require('../utils.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1cfm7_1";
const content = "_content_1cfm7_12";
const labelContainer = "_label-container_1cfm7_27";
const heading = "_heading_1cfm7_32";
const description = "_description_1cfm7_53";
const textContent = "_text-content_1cfm7_63";
const mediaContent = "_media-content_1cfm7_76";
const ctaContainer = "_cta-container_1cfm7_84";
const subscriptionForm = "_subscription-form_1cfm7_98";
const ctaDisclaimer = "_cta-disclaimer_1cfm7_112";
const subscriptionFormDisclaimer = "_subscription-form-disclaimer_1cfm7_124";
const styles = {
	root: root,
	content: content,
	labelContainer: labelContainer,
	heading: heading,
	description: description,
	textContent: textContent,
	mediaContent: mediaContent,
	ctaContainer: ctaContainer,
	subscriptionForm: subscriptionForm,
	ctaDisclaimer: ctaDisclaimer,
	subscriptionFormDisclaimer: subscriptionFormDisclaimer
};

const HeroStandard = ({ backgroundColor = "neutral100", ctaColor = "primary", isSubscriptionForm = false, subscriptionPlaceholder = "Email address", heading, description, ctaText, ctaHref, ctaTarget, ctaDisabled = false, ctaDisclaimer, onCtaClick, onCtaKeyDown, onSubscriptionFormSubmit, children, maxWidth = 1170, label, labelIcon, labelColor }) => {
  const mappedBackgroundColor = components_marketing_Hero_utils.transformBackgroundColor(backgroundColor);
  components_marketing_Hero_utils.validateZapierBackgroundAccessibility(mappedBackgroundColor, isSubscriptionForm, !!ctaDisclaimer);
  const getCtaComponent = () => {
    const color = components_marketing_Hero_utils.getSupportedCTAColor(ctaColor, mappedBackgroundColor);
    return React__default.default.createElement(
      "div",
      null,
      React__default.default.createElement(components_navigation_LegacyButton_Button.LegacyButton, { children: ctaText, href: !isSubscriptionForm ? ctaHref : void 0, onClick: onCtaClick, onKeyDown: onCtaKeyDown, isFullWidth: true, size: isSubscriptionForm ? "medium" : "large", type: isSubscriptionForm ? "submit" : "button", target: ctaTarget, disabled: ctaDisabled, color: color === "primary-alt" ? "primary" : color })
    );
  };
  const isDisclaimerElement = !!ctaDisclaimer && React.isValidElement(ctaDisclaimer);
  return React__default.default.createElement(
    "div",
    { className: styles.root, style: {
      "--_zds-hero-background-color": theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[mappedBackgroundColor]],
      "--_zds-hero-heading-color": theme_Colors.Colors[components_marketing_Hero_utils.mapBackgroundColorToV5TextColorName(mappedBackgroundColor)],
      "--_zds-hero-description-color": theme_Colors.Colors[components_marketing_Hero_utils.mapBackgroundColorToV5HeadingColorName(mappedBackgroundColor)],
      "--_zds-hero-content-width": `${maxWidth}px`
    }, "data-zds": true },
    React__default.default.createElement(
      "div",
      { className: styles.content, "data-zds": true },
      React__default.default.createElement(
        "div",
        { className: styles.textContent, "data-zds": true },
        label && React__default.default.createElement(
          "div",
          { className: styles.labelContainer, "data-zds": true },
          React__default.default.createElement(components_display_Tag_Tag.Tag, { variant: labelColor }, labelIcon ? React__default.default.createElement(
            components_layout_Grid_Grid.Grid,
            { alignItems: "center", columns: "auto max-content", gap: 5 },
            React__default.default.createElement(components_display_Icon_Icon.Icon, { name: labelIcon, size: 20 }),
            label
          ) : label)
        ),
        React__default.default.createElement(components_display_Heading_Heading.Heading, { className: styles.heading }, heading),
        description && React__default.default.createElement("div", { className: styles.description, "data-zds": true }, description),
        ctaText && (ctaHref || onCtaClick || isSubscriptionForm) && React__default.default.createElement("div", { className: clsx__default.default(styles.ctaContainer, isSubscriptionForm && styles.subscriptionForm), "data-zds": true }, isSubscriptionForm ? React__default.default.createElement(components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer.SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder, onSubmit: onSubscriptionFormSubmit, renderButton: () => getCtaComponent(), disclaimerTextColor: mappedBackgroundColor === "neutral100" ? "primary" : "secondary" }) : React__default.default.createElement(
          React.Fragment,
          null,
          React__default.default.createElement("div", { "data-zds": true }, getCtaComponent()),
          ctaDisclaimer && React__default.default.createElement("div", { className: clsx__default.default(styles.ctaDisclaimer, isSubscriptionForm && styles.subscriptionFormDisclaimer), "data-zds": true }, isDisclaimerElement ? ctaDisclaimer : React__default.default.createElement(components_display_Text_Text.Text, { tag: "p", type: "Body1", color: components_marketing_Hero_utils.mapBackgroundColorToV5HeadingColorName(mappedBackgroundColor) }, ctaDisclaimer))
        ))
      ),
      React__default.default.createElement("div", { className: styles.mediaContent, "data-zds": true }, children)
    )
  );
};

exports.HeroStandard = HeroStandard;
//# sourceMappingURL=HeroStandard.cjs.js.map
